module.exports = __webpack_public_path__ + "static/media/maca.4581c028.png";